//
//
//GENERAL
//
//
const Q_GENERAL_1 = 'How do I reset my password?';
const A_GENERAL_1 =
  'To reset your password, follow these steps:\n1. Go to the HandOff login page.\n2. Click on the "Forgot Password" or "Reset Password" link.\n3. Enter your email address associated with your HandOff account.\n4. You will receive an email with instructions on how to reset your password. Follow the link in the email and set a new password for your account.';

const Q_GENERAL_2 =
  'What is the process for resolving disputes between Lenders and Borrowers?';
const A_GENERAL_2 =
  'The resolution process can vary depending on the individual situation, but here are some general guidelines. Please utilize the chat feature in the HandOff app to contact the other party involved in the rental and work towards a resolution. More specific guidelines can be found under the individual Lender/Borrower sections';

const Q_GENERAL_3 = 'Are there any service fees or hidden costs?';
const A_GENERAL_3 =
  'HandOff is completely free for both lenders and borrowers!';

const Q_GENERAL_4 = 'How does payment work?';
const A_GENERAL_4 =
  'Payment for a rental is handled between the Lender and the Borrower. We recommend payment is due at the start of the rental period when the item is transferred to the Borrower.';

const Q_GENERAL_5 = 'How can I deactivate or delete my HandOff account?';
const A_GENERAL_5 =
  'Please contact us using the contact information located at the bottom of the page to request your account be deactivated or deleted. Please send the email from the email address that you registered with.';

const Q_GENERAL_6 = 'Can I provide feedback or suggestions to improve HandOff?';
const A_GENERAL_6 =
  'Yes! We value our users feedback and strive to tailor our application to the needs of our users. Feedback can be provided at the bottom of this page or in the Settings page of our app.';

const Q_GENERAL_7 = "How can I contact HandOff's customer service?";
const A_GENERAL_7 =
  'You can submit a customer service form at the bottom of this page, and a HandOff customer service representative will be in contact with you within 3-5 business days.';

const Q_GENERAL_8 = "How does HandOff's rating and review system work?";
const A_GENERAL_8 =
  'HandOff’s rating and review system exists to provide Lenders and Borrowers with information on who they are lending their items to or borrowing from, and are meant to encourage a helpful and safe lending community.';

const Q_GENERAL_9 =
  "How can I get involved with HandOff's community or events?";
const A_GENERAL_9 =
  'We’re excited to engage with our community! Join our movement by signing up for our email list to stay up to date with all things HandOff!';

const Q_GENERAL_10 = 'How do I give feedback or rate a borrower?';
const A_GENERAL_10 =
  'Feedback and rating takes place after the rental agreement ends.';

//
//
//Lender
//
//
const Q_LENDER_1 = 'Can I cancel my booking? If so, how?';
const A_LENDER_1 =
  'Cancellation policies may vary. You should review the cancellation policy provided when you make a booking. If you need to cancel, please contact the Borrower through the HandOff App as soon as possible and follow the cancellation process outlined in the policy.';

const Q_LENDER_2 = 'How do I set pricing for my items?';
const A_LENDER_2 =
  'You can set the price of your item when you create a listing through the HandOff App! If you ever want to update the price of your item, navigate to Profile → My Listings and select the item that you would like to update.';

const Q_LENDER_3 = 'What kinds of items can I lend out?';
const A_LENDER_3 =
  'You can lend out nearly any item, as long as it meets our Community Guidelines. Take a look at what others have listed on the marketplace, and also take a look at the rent request page to see if you have any items that can fulfill the request!';

const Q_LENDER_4 = 'How will I be paid?';
const A_LENDER_4 =
  'Payment method can be any form of payment that you accept. We suggest that you accept either cash or utilize a payment service such as Venmo, CashApp, or PayPal. We advise that you do not accept checks, as it can be difficult to verify if the check is valid or if it will cash at the time of payment.';

const Q_LENDER_5 = 'When will I be paid?';
const A_LENDER_5 =
  'We recommend payment is due at the start of the rental period when the item is transferred to the Borrower.';

const Q_LENDER_6 = 'What happens if an item I lent is damaged?';
const A_LENDER_6 =
  'The Borrower is responsible for any major damages to the property that they have borrowed, and they should pay for any major damage to the property. While this is the case, please understand that normal wear and tear is expected when items are being used. By lending your items, you are offsetting the cost that you initially paid for the item, and are being paid for this additional wear on your property.';

const Q_LENDER_7 = 'What happens if an item is not returned?';
const A_LENDER_7 =
  'You should first try to contact the Borrower using the HandOff App. If the user is unresponsive, please contact local authorities to deal with the situation.';

const Q_LENDER_8 = 'How do I deal with overdue items?';
const A_LENDER_8 =
  'Please contact the Borrower through the HandOff app. Please utilize the review system to indicate to future Lenders that this Borrower was late with their return.';

const Q_LENDER_9 = 'What items are prohibited to lend on HandOff?';
const A_LENDER_9 =
  'Please refer to our Community Guidelines for prohibited items.';

const Q_LENDER_10 = 'Can I list a rental bundle (multiple items together)?';
const A_LENDER_10 =
  'Currently, there is no way to link individual listings together on our App to make a bundle. However, if there are multiple items that make sense to rent together, you can include all of these items in one listing, such as a table and chairs.';

const Q_LENDER_11 = 'What do I do if I cannot fulfill a rental request?';
const A_LENDER_11 =
  'Please contact the Borrower through the App and inform them that the item is no longer available for rent. Please note that this can lead to a poor review and a bad experience for the Borrower, so please avoid canceling a rental agreement unless absolutely necessary.';

const Q_LENDER_12 = 'Can I pause my listing temporarily?';
const A_LENDER_12 =
  "Currently, there is no way to temporarily pause a listing. You may want to consider removing the listing if it's not available for an extended period.";

const Q_LENDER_13 = 'What if I need to use the item I have listed for rent?';
const A_LENDER_13 =
  "If you need to use the item you've listed, it's best to remove the listing temporarily. This ensures that Borrowers don't request it while you need it.";

const Q_LENDER_14 = 'Are there any tax implications for the income I generate?';
const A_LENDER_14 =
  'HandOff cannot provide financial advice or accurate tax information for all situations, and recommends contacting a tax professional. However, any money generated from using HandOff is generally considered income and should be reported.';

const Q_LENDER_15 = 'What if a borrower wants to purchase my item?';
const A_LENDER_15 =
  'This can be a common occurrence! If a user finds an item useful and they rent it multiple times, they may consider purchasing the item. This may be a good opportunity for you to sell your item. You may consider renting this item in the future when you need it, or use the money from selling your item to purchase a new version of that item.';

//
//
//Borrower
//
//
const Q_BORROWER_1 = 'Can I extend the rental period?';
const A_BORROWER_1 =
  'Currently, you cannot extend a rental agreement. If you want to keep the item for longer, please submit another rental request.';

const Q_BORROWER_2 = 'Can I cancel my booking? If so, how?';
const A_BORROWER_2 =
  'After a rental agreement has been accepted, there is no way to cancel it. If you are not going to pick up your item, please contact the Lender through the HandOff App. Please note that this can lead to a poor review for you and a bad experience for the Lender, so please avoid this unless absolutely necessary.';

const Q_BORROWER_3 = 'Can I negotiate rental prices with the Lender?';
const A_BORROWER_3 =
  'Yes, you can negotiate the rental price! However, please be respectful of the Lender, and understand that they may not be willing to negotiate the price.';

const Q_BORROWER_4 =
  "What should I do if I'm unable to return an item on time?";
const A_BORROWER_4 =
  'You should contact the Lender using the HandOff App to let them know that you will not be able to return the item on time. Please note that this can lead to a poor review and a bad experience for the Lender, as they may need the item or are planning on lending the item to another Borrower, so please strive to return the item on time unless unavoidable.';

const Q_BORROWER_5 = 'What if I receive an item that is in poor condition?';
const A_BORROWER_5 =
  'Please inspect the state of the item at the time of pickup. If the item does not meet the description on the post, consider leaving a review of the Lender to help future Borrowers.';

const Q_BORROWER_6 =
  'How do I contact the Lender if I have issues with the item?';
const A_BORROWER_6 =
  'Please use the HandOff App to contact the Lender if you have any questions or issues with an item that you have borrowed.';

const Q_BORROWER_7 = 'Can I rent an item long-term?';
const A_BORROWER_7 =
  'Absolutely! Oftentimes, Lenders will be willing to negotiate a lower price for long-term rentals. You can use the HandOff app to negotiate a price for your long term rental.';

const Q_BORROWER_8 = 'Can I request an item that is not listed?';
const A_BORROWER_8 =
  'Yes! If you don’t see an item that you would like to rent on the Marketplace, please utilize the Want Request section to notify others in your community that you are interested in borrowing that item.';

const Q_BORROWER_9 = 'How do I give feedback or rate a lender?';
const A_BORROWER_9 =
  'Feedback and rating takes place after the rental agreement ends.';

//
//
//ALL QUESTIONS
//
//
const QUESTIONS_GENERAL = [
  Q_GENERAL_1,
  Q_GENERAL_2,
  Q_GENERAL_3,
  Q_GENERAL_4,
  Q_GENERAL_5,
  Q_GENERAL_6,
  Q_GENERAL_7,
  Q_GENERAL_8,
  Q_GENERAL_9,
  Q_GENERAL_10
];

const QUESTIONS_LENDER = [
  Q_LENDER_1,
  Q_LENDER_2,
  Q_LENDER_3,
  Q_LENDER_4,
  Q_LENDER_5,
  Q_LENDER_6,
  Q_LENDER_7,
  Q_LENDER_8,
  Q_LENDER_9,
  Q_LENDER_10,
  Q_LENDER_11,
  Q_LENDER_12,
  Q_LENDER_13,
  Q_LENDER_14,
  Q_LENDER_15
];

const QUESTIONS_BORROWER = [
  Q_BORROWER_1,
  Q_BORROWER_2,
  Q_BORROWER_3,
  Q_BORROWER_4,
  Q_BORROWER_5,
  Q_BORROWER_6,
  Q_BORROWER_7,
  Q_BORROWER_8,
  Q_BORROWER_9
];

//
//
//ALL ANSWERS
//
//
const ANSWERS_GENERAL = [
  A_GENERAL_1,
  A_GENERAL_2,
  A_GENERAL_3,
  A_GENERAL_4,
  A_GENERAL_5,
  A_GENERAL_6,
  A_GENERAL_7,
  A_GENERAL_8,
  A_GENERAL_9,
  A_GENERAL_10
];

const ANSWERS_LENDER = [
  A_LENDER_1,
  A_LENDER_2,
  A_LENDER_3,
  A_LENDER_4,
  A_LENDER_5,
  A_LENDER_6,
  A_LENDER_7,
  A_LENDER_8,
  A_LENDER_9,
  A_LENDER_10,
  A_LENDER_11,
  A_LENDER_12,
  A_LENDER_13,
  A_LENDER_14,
  A_LENDER_15
];

const ANSWERS_BORROWER = [
  A_BORROWER_1,
  A_BORROWER_2,
  A_BORROWER_3,
  A_BORROWER_4,
  A_BORROWER_5,
  A_BORROWER_6,
  A_BORROWER_7,
  A_BORROWER_8,
  A_BORROWER_9
];

//
//
//SECTIONS
//
//
export const SECTIONS = [
  { title: 'General', answers: ANSWERS_GENERAL, questions: QUESTIONS_GENERAL },
  { title: 'Lender', answers: ANSWERS_LENDER, questions: QUESTIONS_LENDER },
  {
    title: 'Borrower',
    answers: ANSWERS_BORROWER,
    questions: QUESTIONS_BORROWER
  }
];
